import { OpeningApprovalsService } from 'api-clients/monolith';
import { useCallback } from 'react';

import { useApiService } from './useApiService';

/**
 * Fetches opening approval approver groups for a given opening ID.
 *
 * @param openingId - The opening ID to get the approver groups for.
 * @returns { approverGroups, isLoading, isError, ...rest } - The first page of approver groups, whether a request for them is in flight or failed, and the useApiService result helpers.
 */
export function useOpeningApprovalApproverGroupsForOpening(openingId: string) {
  const fetchApproverGroups = useCallback(
    () =>
      OpeningApprovalsService.getInternalApiOpeningApprovalApproverGroupsApproverGroupsForOpening(
        openingId,
      ),
    [openingId],
  );

  const { result, ...rest } = useApiService(fetchApproverGroups);

  const approverGroups =
    result.status === 'ready' ? result.data?.approver_groups : undefined;

  return {
    approverGroups,
    isLoading: result.isLoading,
    isError: result.isError,
    ...rest,
  };
}
